import Vue from 'vue';
import VueResource from 'vue-resource';

Vue.use(VueResource);

export const fncPopulateProcessList = ({ commit, dispatch, state, rootState }, payload) => {
  var manuId = '';
  if( payload != '' ) {
    manuId = payload;
  } else {
    var objAuth = JSON.parse(rootState.objAuthorize);
    var manuId = objAuth.manufacturer;
  }
		var processDetails = { manufacturer: manuId };
		// var processDetails = { manufacturer: payload };
		Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Process.php?a=getProcesses', processDetails, rootState.headerDetails)
			.then(response => {
				return response.json();
			}, error => {
				console.log(error);
			}).then(data => {
				commit('setProcessList', data);
				if (payload != undefined && payload.reload == true) {
					var snackDetails = { color: 'success', message: 'Departmental Service Forms reload successfull', display: true };
					commit('setSnack', snackDetails);
				}
			});
};

export const fncProcessDelete = ({ commit, dispatch, state, rootState }, payload) => {
  var objAuth = JSON.parse(rootState.objAuthorize);
  var processDetails = { id: payload.processId };
  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Process.php?a=deleteProcess', processDetails, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      console.log(error);
    }).then(data => {
    commit('setProcessList', data);
    if (payload = 'true') {
      var snackDetails = { color: 'success', message: 'Departmental Service Form removed successfully', display: true };
      commit('setSnack', snackDetails);
      dispatch({
        type: 'fncPopulateProcessList'
      });
    }
  });
};

export const fncProcessAdd = ({ commit, dispatch, state, rootState }, payload) => {
  var objAuth = JSON.parse(rootState.objAuthorize);
  var processDetails = { manufacturer: objAuth.manufacturer, name: payload.processName, token: payload.processToken, department: payload.processDepartment, tabs: payload.processTabs, ranges: payload.processRanges, codes: payload.processCodes, form: payload.processTabForms, processHsArticleName: payload.processHsArticleName, processHsArticleNumber: payload.processHsArticleNumber, processHsArticlePrice: payload.processHsArticlePrice, popupPayment: payload.popupPayment, popupContact: payload.popupContact, popupRequest: payload.popupRequest, popupVisit: payload.popupVisit, popupCalculator: payload.popupCalculator, calculator_links: payload.calculatorLinks, process_roles: payload.processRoles, starting_rules: payload.startingRules, checkout_store: payload.checkoutBranch,override_callout: payload.overrideCallout };
  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Process.php?a=createProcess', processDetails, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      console.log(error);
    }).then(data => {
    commit('setProcessList', data);
    if (payload = 'true') {
      commit('hideModal');
      var snackDetails = { color: 'success', message: 'Departmental Service Form added successfully', display: true };
      commit('setSnack', snackDetails);
      commit('hideModal');
      dispatch('fncPopulateProcessList',objAuth.manufacturer);
    }
  });
};


export const fncProcessUpdate = ({ commit, dispatch, state, rootState }, payload) => {
  var objAuth = JSON.parse(rootState.objAuthorize);
  var processDetails = { manufacturer: objAuth.manufacturer, details: payload };

  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Process.php?a=editProcess', processDetails, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      console.log(error);
    }).then(data => {
    commit('setProcessList', data);
    if (payload = 'true') {
      commit('hideModal');
      var snackDetails = { color: 'success', message: 'Departmental Service Form updated successfully', display: true };
      commit('setSnack', snackDetails);
      commit('hideModal');
      dispatch('fncPopulateProcessList',objAuth.manufacturer);
    }
  });
};

export const fncProcessDuplicate = ({ commit, dispatch, state, rootState }, payload) => {
  var objAuth = JSON.parse(rootState.objAuthorize);
  var processDetails = { item: payload.item };

  console.log( processDetails );
  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Process.php?a=duplicateProcess', processDetails, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      console.log(error);
    }).then(data => {
      if( data == true || data == 'true' ) {
        var snackDetails = { color: 'success', message: 'Departmental Service Form has been duplicated successfully', display: true };
        commit('setSnack', snackDetails);
      } else {
        var snackDetails = { color: 'error', message: 'Departmental Service Form duplication was unsuccessful', display: true };
        commit('setSnack', snackDetails);
      }
      dispatch('fncPopulateProcessList');
      //window.location.reload();
  });
};

export const fncPopulateCommercialKams = ({ commit, dispatch, state, rootState }, payload) => {

  var kamDetails = { params: payload };
  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'User.php?a=getCommercialKams', kamDetails, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      console.log(error);
    }).then(data => {
    commit( 'fncSetCommercialKams', data );
  });
}

export const fncPopulateCommercialOriginator = ({ commit, dispatch, state, rootState }, payload) => {

  var kamDetails = {params: payload};
  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'User.php?a=getCommercialOriginator', kamDetails, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      console.log(error);
    }).then(data => {
    commit('fncSetCommercialOriginators', data);
  });
}

export const fncGenerateLink = ({ commit, dispatch, state, rootState }, payload) => {

  var objAuth = JSON.parse(rootState.objAuthorize);
  var params = { manufacturer: objAuth.manufacturer, token: payload.token, process: payload.id, store: payload.store, client_name: payload.customerName, client_email: payload.customerEmail, agentEmail: payload.agentEmail  };

  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'System.php?a=createTokenAuth', params, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      console.log(error);
    }).then(data => {

      console.log('Auth');
      console.log( data );

      if( data != '' ) {

        var params = { auth: data, manufacturer: objAuth.manufacturer, token: payload.token, process: payload.id, store: payload.store, client_name: payload.customerName, client_email: payload.customerEmail, agentEmail: payload.agentEmail  };

        Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'System.php?a=checkTokenAuth', params, rootState.headerDetails)
          .then(response => {
            return response.json();
          }, error => {
            console.log(error);
          }).then(d => {

            if( d == true ) {

                  var directUrl = window.location.origin;

                  if( payload.agentEmail != '' ) {
                    directUrl = directUrl + '/#/survey?agentEmail='+payload.agentEmail+'&customer='+payload.customerEmail+'&client_name='+payload.customerName+'&store='+payload.store+'&client_email='+payload.customerEmail+'&client_contact='+payload.customerContact+'&auth='+data+'&process='+payload.id+'&manufacturer='+objAuth.manufacturer;
                  } else {
                    directUrl = directUrl + '/#/survey?customer='+payload.customerEmail+'&client_name='+payload.customerName+'&store='+payload.store+'&client_email='+payload.customerEmail+'&client_contact='+payload.customerContact+'&auth='+data+'&process='+payload.id+'&manufacturer='+objAuth.manufacturer;
                  }

                  //navigator.clipboard.writeText(directUrl);

                  var snackDetails = { color: 'success', message: 'The service form link was copied to the clipboard', display: true };
                  commit('setSnack', snackDetails);

              commit('fncSetGeneratedLink', directUrl);

            } else {

              var snackDetails = { color: 'error', message: 'The service form link could not be generated', display: true };
              commit('setSnack', snackDetails);

            }

        });

      }

  });
}

export const fncPopulateErf = ({ commit, dispatch, state, rootState }, payload) => {

  //var objAuth = JSON.parse(rootState.objAuthorize);

  //const manufacturer = new URLSearchParams(window.location.manufacturer);

  //var setData = { manufacturer: manufacturer };

  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Process.php?a=getErfData', [], rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      console.log(error);
    }).then(data => {
    
      commit('fncSetErfNumbers', data);
  });

  
}